<div class="fms-test-fly-cut-modal-content" vngTourAnchor="step10">
  <header>
    <h3>Test <strong>My FlyCut</strong></h3>
    <!-- R: raw <button> + inline SVG -> library [vng-icon-button] (attribute
         selector, so the data-fms-heap hook stays on the SAME element).
         R8: stays raw (not app-dialog-close-button) precisely because of that
         Heap hook — the glyph is sized explicitly to 20px to match the shared
         close button. -->
    <button
      vng-icon-button
      type="button"
      color="none"
      class="fms-test-fly-cut-modal-x-button"
      [attr.data-fms-heap]="isOnboarding ? 'walk-me-modal-step-10-close-modal' : ''"
      (click)="close()"
    >
      <vng-icon name="close" [outline]="false" [size]="20"></vng-icon>
    </button>
  </header>
  <section>
    <!-- R12: mat-radio-group/-button -> vng-radio-group/-button. No formControl
         existed here before (test-flycut is R12's documented (click)-driven
         exception) — [ngModel]="testElement" one-way seeds/keeps the visual
         checked state in sync (vng-radio-button has no [checked] @Input; the
         group derives it from its own CVA value), while the existing (click)
         handlers keep driving testElement exactly as before. -->
    <vng-radio-group
      aria-label="Select an option"
      orientation="horizontal"
      [ngModel]="testElement"
      [ngModelOptions]="{ standalone: true }"
    >
      <vng-radio-button
        color="primary"
        (click)="onChangeEditor('text')"
        class="right-gap"
        value="text"
        vngTourAnchor="step8"
      >
        Simple Text Preview
        <ng-template #popoverContent1>
          <strong>Simple Text Preview</strong> <br />
          Simple Text editors like LinkedIn, Slack or WhatsApp online do not allow you to embed multimedia (images,
          GIFs, etc) and hyperlinks.
        </ng-template>
        <vng-icon
          name="help_center"
          [outline]="false"
          color="purple"
          class="help-icon"
          [ngbPopover]="popoverContent1"
          [popoverClass]="'fms-testing-center-popover'"
        >
        </vng-icon>
      </vng-radio-button>

      <vng-radio-button
        color="primary"
        (click)="onChangeEditor('edit')"
        value="edit"
        vngTourAnchor="step9"
        class="right-gap"
      >
        Rich Text Preview
        <ng-template #popoverContent2>
          <strong>Rich Text Preview</strong> <br />
          Rich Text platforms like Gmail or Outlook allow you to embed multimedia (images, GIFs, etc) and hyperlinks.
        </ng-template>
        <vng-icon
          name="help_center"
          [outline]="false"
          color="purple"
          class="help-icon"
          [ngbPopover]="popoverContent2"
          [popoverClass]="'fms-testing-center-popover'"
        >
        </vng-icon>
      </vng-radio-button>
    </vng-radio-group>

    <div *ngIf="testElement == 'text'" class="w-100">
      <textarea
        (ngModel)="(textArea)"
        [placeholder]="textArea"
        (click)="checkPlaceHolder('textArea')"
        (blur)="checkPlaceHolder('textArea')"
        [ngModelOptions]="{ standalone: true }"
        class="textarea-test"
      ></textarea>
    </div>
    <div *ngIf="testElement != 'text'" class="demoEditor-container">
      <div
        class="demoEditor"
        id="demoEditor"
        (focusin)="hidePlaceholder()"
        (focusout)="showPlaceholder()"
        contenteditable="true"
        (input)="onEditorInput($event)"
      ></div>

      <div class="placeholder placeholder-absolute fms-test-flycut-placeholder" *ngIf="placeholder">
        {{ plc?.testingRichEditor }}
      </div>
    </div>
  </section>
  <footer>
    <span>
      Type the FlyCut <strong>{{ shortcut.shortcut }}</strong> in the text box to preview it.
      <span *ngIf="testElement == 'text'">Switch to “Rich Text Preview” to access elements like bold, underline.</span>
    </span>
  </footer>
</div>
